export default __webpack_public_path__ + "static/media/featured_01.104efd37.jpg";